import cnRequest from '@alife/cnc-cn-request-wms';
let sourceType = 'asn';
export function setSourceType(source) {
    sourceType = source;
}
const getUrl = (name) => {
    const isPreEnv = location.hostname.indexOf('pre-') > -1;
    const isDailyEnv = location.hostname.indexOf('taobao.test') > -1 ||
        location.hostname.indexOf('daily') > -1;
    let inboundHostName;
    if (isPreEnv) {
        inboundHostName = 'https://pre-inbound-wms.cainiao.com/';
    }
    else if (isDailyEnv) {
        inboundHostName = 'https://inbound-wms.daily.taobao.net/';
    }
    else {
        inboundHostName = 'https://inbound-wms.cainiao.com/';
    }
    const urlPrefix = {
        asn: '/',
        vehicle: inboundHostName,
    }[sourceType];
    const pathNmae = {
        getCnValueAddedServiceType: 'api/cnSelfVas/getCnValueAddedServiceType',
        checkCanUseCnSelfVas: 'api/cnSelfVas/checkCanUseCnSelfVas',
        createSelfVasItems: 'api/cnSelfVas/createSelfVasItems',
        alterSelfVasItems: 'api/cnSelfVas/alterSelfVasItems',
        getVasSelfPayerInfo: 'api/cnSelfVas/getVasSelfPayerInfo',
        cancelSelfVasItems: 'api/cnSelfVas/cancelSelfVasItems',
        saveVasSelfPayerInfo: 'api/cnSelfVas/saveVasSelfPayerInfo',
        querySelfVasDetailList: 'api/cnSelfVas/querySelfVasDetailList',
        printValueAddedOrder: 'api/print/printValueAddedOrder',
        getCnVasPartnerInfo: 'api/cnSelfVas/getCnVasPartnerInfo',
        saveCnVasPartnerInfo: 'api/cnSelfVas/saveCnVasPartnerInfo',
        getCnVasPayerInfo: 'api/cnSelfVas/getCnVasPayerInfo',
        saveCnVasPayerInfo: 'api/cnSelfVas/saveCnVasPayerInfo',
        refreshCnVasPaymentResults: 'api/cnSelfVas/refreshCnVasPaymentResults',
        askPreChargeAndCashierUrl: 'api/cnSelfVas/askPreChargeAndCashierUrl',
        asnReceiveInfo: 'api/asn/asnReceiveInfo',
        finish: 'api/asn/finish',
        headDetail: 'api/asn/headDetail',
        asnOrderProcess: 'api/asn/asnOrderProcess',
        asnSummary: 'api/asn/asnSummary',
        asnOrderDetails: 'api/asn/asnOrderDetails',
        printItemBarcode: 'api/print/printItemBarcode',
        planOrderDistribution: 'api/asn/planOrderDistribution',
        planOrders: 'api/asn/planOrders',
        deliverInfo: 'api/asn/deliverInfo',
        operateLog: 'api/asn/operateLog',
        // 菜鸟增值服务
        askPreCharge: '/api/asn/valueAddedService/askPreCharge',
        askCashierUrl: '/api/asn/valueAddedService/askCashierUrl',
        printAsn: '/api/print/printAsn',
        // askPreChargeAndCashierUrl:
        //   '/api/asn/valueAddedService/askPreChargeAndCashierUrl',
        // checkBeforePreCharge: '/api/asn/valueAddedService/checkBeforePreCharge',
        askPreChargeList: 'https://oneapi.alibaba-inc.com/mock/l2k7ha29/api/cp/packageDrop/list',
        // 菜鸟增值服务 - 三期
        serviceList: 'api/asn/valueAddedService/serviceList',
        serviceInfo: 'api/asn/valueAddedService/serviceInfo',
        checkBeforePreCharge: 'api/asn/valueAddedService/checkBeforePreCharge', // 增值服务 - 列表 - 确认服务项
        // 增值服务 - 列表 - 确认服务项 - 预计费金额和收银台地址
    }[name];
    return `${urlPrefix}${pathNmae || name}`;
};
const commonPost = async (type, data) => {
    const options = {
        url: getUrl(type),
        method: 'POST',
        data: {
            ...(data || {}),
            bizTypeCode: {
                asn: 'INBOUND_ASN',
                vehicle: 'TOB_OUTBOUND_TP',
            }[sourceType],
        },
        needCheckCurDomainCsrf: true,
    };
    if (sourceType === 'vehicle') {
        options.withCredentials = true;
    }
    return cnRequest(options);
};
const commonGet = async (type, data) => {
    const options = {
        url: getUrl(type),
        method: 'GET',
        data: {
            ...(data || {}),
            bizTypeCode: {
                asn: 'INBOUND_ASN',
                vehicle: 'TOB_OUTBOUND_TP',
            }[sourceType],
        },
        needCheckCurDomainCsrf: true,
    };
    if (sourceType === 'vehicle') {
        options.withCredentials = true;
    }
    return cnRequest(options);
};
export function checkCanUseCnSelfVas(data) {
    return commonPost('checkCanUseCnSelfVas', data);
}
export function getCnValueAddedServiceType() {
    return commonGet('getCnValueAddedServiceType', {});
}
export function createSelfVasItems(data) {
    return commonPost('createSelfVasItems', data);
}
export function alterSelfVasItems(data) {
    return commonPost('alterSelfVasItems', data);
}
export function getVasSelfPayerInfo(data) {
    return commonPost('getVasSelfPayerInfo', data);
}
export function cancelSelfVasItems(data) {
    return commonPost('cancelSelfVasItems', data);
}
export function saveVasSelfPayerInfo(data) {
    return commonPost('saveVasSelfPayerInfo', data);
}
export function querySelfVasDetailList(data) {
    return commonPost('querySelfVasDetailList', data);
}
export function printValueAddedOrder(data) {
    return commonPost('printValueAddedOrder', {
        ...data,
        warehouseId: window?.headerGlobalData?.getData('warehouseId') || '',
    });
}
export function getCnVasPartnerInfo(data) {
    return commonPost('getCnVasPartnerInfo', data);
}
export function getCnVasPayerInfo(data) {
    return commonPost('getCnVasPayerInfo', data);
}
export function saveCnVasPartnerInfo(data) {
    return commonPost('saveCnVasPartnerInfo', data);
}
export function saveCnVasPayerInfo(data) {
    return commonPost('saveCnVasPayerInfo', data);
}
export function refreshCnVasPaymentResults(data) {
    return commonPost('refreshCnVasPaymentResults', data);
}
export function askPreChargeAndCashierUrl(data) {
    return commonPost('askPreChargeAndCashierUrl', data);
}
